import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { User } from '../interfaces/user.interface'; // Ajusta la ruta si es necesario

@Component({
    selector: 'app-view-representante-modal',
    templateUrl: './view-representante-modal.component.html',
})
export class ViewRepresentanteModalComponent implements OnInit {
    @Input() representante: User['representante'];

    isLoading = false;
    errorMessage: string | null = null;

    constructor(public activeModal: NgbActiveModal) {}

    ngOnInit(): void {
        if (!this.representante) {
            this.errorMessage = 'No se proporcionaron datos del representante.';
        }
    }

    getNombreCompleto(): string {
        if (!this.representante) {
            return 'N/A';
        }
        return `${this.representante.nombre || ''} ${this.representante.apellido || ''}`.trim();
    }
}
